export default __webpack_public_path__ + "static/ax-banner-poster-c8e9a02ea91f9a016dc687e259017856.jpg";